const STORAGE_KEY = 'barcodeCameraDeviceId';

export const loadSavedCameraDeviceId = () => {
  try {
    const id = localStorage.getItem(STORAGE_KEY);
    return id && typeof id === 'string' ? id : null;
  } catch {
    return null;
  }
};

export const saveCameraDeviceId = (deviceId) => {
  try {
    if (!deviceId) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }
    localStorage.setItem(STORAGE_KEY, deviceId);
  } catch {
    /* ignore quota / private mode */
  }
};

export const clearCameraDeviceId = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
};
